import { gql } from '@apollo/client';

export default gql`
  mutation DeleteProductImageMutation($productImageId: Int!) {
    deleteProductImageById(input: { id: $productImageId }) {
      productImage {
        id
      }
    }
  }
`;
